<template>
  <div :class="setFormClass">
    <input
        class="form-check-input"
        type="checkbox"
        :id="checkId"
        :value="value"
        :disabled="disabled"
        v-model="checkList"
        @click="updateCheckValue" />
    <label :for="checkId" class="form-check-label"><slot></slot></label>
  </div>
</template>

<script>
export default {
  props: {
    inline: Boolean,
    value: String,
    checked: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      formClass: 'fx_form',
      checkList: [],
    };
  },
  computed: {
    setFormClass() {
      if (this.inline) return `${this.formClass} inline`;
      return this.formClass;
    },
    checkId() {
      return `check${this.value}`;
    },
  },
  methods: {
    updateCheckValue(event) {
      this.$emit('click', event);
    },
  },
  created() {
    if (this.checked) this.checkList.push(this.value);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/control/checkbox/Checkbox.vue